import { proxy } from "valtio";
import { emptyToUndefined } from "src/utils/common-util";

export enum EnumPageType {
    WikifolioDetail = "WikifolioDetail",
    Feed = "Feed",
    ExternalNews = "ExternalNews",
    MarketIndicatorDetail = "MarketIndicatorDetail",
    PodcastArticle = "PodcastArticle",
}

export interface IFeedTrackingStore {
    page?: EnumPageType;
    wikifolioId?: string;
    feedType?: string;
    underlyingIsin?: string;
    setFeedType: (feedType?: string) => void;
}

export interface IFeedTrackingParams {
    page: EnumPageType;
    wikifolioId?: string;
    feedType?: string;
    underlyingIsin?: string;
}

export const feedTrackingStore = proxy({
    page: undefined,
    wikifolioId: undefined,
    feedType: undefined,
    underlyingIsin: undefined,
    setFeedType(feedType?: string) {
        feedTrackingStore.feedType = feedType;
    },
} as IFeedTrackingStore);

export const setTrackingStoreFeedType = (feedType?: string) => {
    feedTrackingStore.setFeedType(emptyToUndefined(feedType));
};

export function initializeFeedTrackingStore(params: IFeedTrackingParams) {
    feedTrackingStore.page = params.page;
    feedTrackingStore.wikifolioId = params.wikifolioId;
    feedTrackingStore.feedType = params.feedType;
    feedTrackingStore.underlyingIsin = params.underlyingIsin;
}
